<template>
  <div>
    <b-modal v-model="show" no-close-on-backdrop no-close-on-esc id="modal-lg" hide-footer modal-class="p-0"
        body-class="p-0" content-class="border-0" header-class="border-0" @close="closeModal()"
        size="lg" ref="modal-edit">
      <template #modal-header="{ close }">
        <button type="button" class="close" @click="close" data-dismiss="modal"> &times;</button>
        <h6 class="modal-title">ビデオが始まりました</h6>
      </template>
      <div class="ratio ratio-16x9">
        <video class="ratio-16x9" controls autoplay>
          <source :src="video.sources[0].src"/>
          Your browser does not support the video tag.
        </video>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import myVideo from "vue-video";
import { filter } from '../../helpers/Vue-Filter'

export default {
  props: ['isShow', 'videoURL', 'dateTilte'],

  filters: {
    ...filter,
  },

  data () {
    return {
      show: false,
      video: {
        sources: [
          {
            src: '',
            // type: "video/mp4",
          },
        ],
        options: {
          autoplay: true,
          volume: 0.6,
        },
      },
    }
  },

  components: {
    // myVideo,
  },

  watch: {
    videoURL: {
      handler (url) {
        this.video.sources[0].src = `${url}`
      },
    },

    isShow: {
      handler (flag) {
        this.show = flag
      },
    },
  },

  created () {
    this.video.sources[0].src = `${this.videoURL}`
    this.show = this.isShow
  },

  computed: {},

  methods: {
    closeModal () {
      this.$emit('closeModal')
      this.dataInsert = {}
    },
  },
}
</script>

<style scoped>
::v-deep .my-class {
  background: #007e41;
  color: white;
  font-weight: 700;
  color: #ffffff;
  font-size: 20px;
}

::v-deep .ratio-16x9 .container .__cov-video-container .__cov-video {
  height: 35em !important;
}

::v-deep .ratio-16x9 .container {
  padding: 0px !important;
}

/* ::v-deep .__cov-contrl-play-btn {
  visibility: hidden;
} */

::v-deep .ratio-16x9 .container .__cov-video-container {
  border-radius: 0 0 0.25em 0.25rem !important;
}

* {
  font-family: "Noto Sans JP";
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-button {
  font-weight: 700 !important;
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.text-table {
  font-weight: 400 !important;
  color: #404040;
}

.text-label {
  font-weight: 500 !important;
  color: #404040;
}

.text-label-filter {
  font-weight: 700 !important;
  color: #404040 !important;
}

.text-link {
  color: #336aff;
}
</style>